import { render, staticRenderFns } from "./Arguments.vue?vue&type=template&id=3619767e&scoped=true"
import script from "./Arguments.vue?vue&type=script&lang=js"
export * from "./Arguments.vue?vue&type=script&lang=js"
import style0 from "./Arguments.vue?vue&type=style&index=0&id=3619767e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3619767e",
  null
  
)

export default component.exports